import { useEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import { useMe } from '../lib/data';

/* Чат поддержки (Chatwoot): кружок в углу на всех страницах (просьба заказчика) + пункт «Поддержка» в меню.
   Кружок поднят над нижней панелью на телефоне и над панелью сохранения в конструкторе (styles/extra.css). Тренер передаётся с подписью HMAC (identifier_hash с сервера):
   имя, телефон, тариф и число клиентов видны поддержке сразу. Пока сервер не отдал настройки
   (нет CHATWOOT_* в API) — пункта нет. */

type CW = { toggle: (s?: 'open' | 'close') => void; setUser: (id: string, u: Record<string, unknown>) => void; setCustomAttributes: (a: Record<string, unknown>) => void; setLocale: (l: string) => void };
declare global {
  interface Window {
    $chatwoot?: CW;
    chatwootSDK?: { run: (o: { websiteToken: string; baseUrl: string }) => void };
    chatwootSettings?: Record<string, unknown>;
  }
}

/* Непрочитанный ответ поддержки — точка у пункта меню */
let unread = false;
const subs = new Set<() => void>();
const setUnread = (v: boolean) => {
  unread = v;
  subs.forEach((f) => f());
};
const useUnread = () =>
  useSyncExternalStore(
    (f) => (subs.add(f), () => subs.delete(f)),
    () => unread,
  );

let loading = false;
let pendingOpen = false;

export function useSupport() {
  const me = useMe().data;
  const cfg = me?.support;
  const dot = useUnread();
  /* В конструкторе кружок выше — над панелью «Сохранить» */
  const { pathname } = useLocation();
  useEffect(() => {
    document.body.classList.toggle('cw-cons', pathname.startsWith('/constructor'));
  }, [pathname]);

  useEffect(() => {
    if (!cfg || !me || loading) return;
    loading = true;
    window.chatwootSettings = { hideMessageBubble: false, locale: 'ru', position: 'right', type: 'standard', darkMode: 'light', launcherTitle: '' };
    window.addEventListener('chatwoot:ready', () => {
      const cw = window.$chatwoot!;
      cw.setUser(cfg.identifier, {
        name: [me.first, me.last].filter(Boolean).join(' ') || 'Тренер',
        phone_number: me.phone || undefined,
        ...(cfg.hash ? { identifier_hash: cfg.hash } : {}),
      });
      cw.setCustomAttributes({ role: 'trainer', plan: me.plan, clients: me.used, client_limit: me.clientLimit, city: me.city || '' });
      if (pendingOpen) cw.toggle('open');
      pendingOpen = false;
    });
    window.addEventListener('chatwoot:on-message', (e: Event) => {
      const m = (e as CustomEvent).detail;
      if (m?.message_type === 1 || m?.message_type === 'outgoing') setUnread(true);
    });
    const s = document.createElement('script');
    s.src = cfg.url + '/packs/js/sdk.js';
    s.async = true;
    s.onload = () => window.chatwootSDK?.run({ websiteToken: cfg.token, baseUrl: cfg.url });
    document.body.appendChild(s);
  }, [cfg, me]);

  if (!cfg) return null;
  return {
    dot,
    open: () => {
      setUnread(false);
      if (window.$chatwoot) window.$chatwoot.toggle('open');
      else pendingOpen = true;
    },
  };
}

/** Открыть чат поддержки откуда угодно (кружок уже на странице — его подключает Shell) */
export function openSupport() {
  setUnread(false);
  if (window.$chatwoot) window.$chatwoot.toggle('open');
  else pendingOpen = true;
}
